
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-error-outline",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-error-outline"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"i-error-outline__triangle",attrs:{"d":"M2.86 14.62L9 4.13l6.14 10.49H2.86z"}}),_c('path',{attrs:{"d":"M9.01 7.95v3.12"}}),_c('path',{attrs:{"stroke-linecap":"square","stroke-miterlimit":"10","d":"M9.01 12.57v.04"}})])
          )
        }
      }
    